import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import "./style.css";

const Pdata= [
    {
        id:1,
        endVal: 20,
        time: 2,
        heading: 'Projects Completed'
    },
    {
        id: 2,
        endVal: 10,
        time: 1,
        heading: 'Happy Clients'
    },
    {
        id: 3,
        endVal: 2,
        time: 1,
        heading: 'Years of Experience'
    }
]

function Progress() {
  return (
    <div className="Progress py-5">
      <div className="container-lg">
        <div className="row g-5">
          {Pdata.map((item)=>(
            <div className="col-md-4" key={item.id}>
            <div className="Progress__counter d-flex flex-column align-items-center">
              <h1 className="Progress__counter__value">
              <CountUp end={item.endVal} redraw={true} duration={item.time}>
                {({ countUpRef, start }) => (
                  <VisibilitySensor onChange={start} delayedCall>
                    <span ref={countUpRef} />
                  </VisibilitySensor>
                )}
              </CountUp>
              <small className="Progress__counter__value__plus">+</small>
              </h1>
              <h4 className="Progress__counter__heading text fs-5">
                {item.heading}
              </h4>
            </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Progress;
